export enum APIPath {
    CAPACITY_FACTORS = 'rates',
    COWORKER_TURN_OVER = 'coworkerTurnover',
    BUDGET_HOURS = 'budget',
    DEFAULT_CONFIG = 'defaultcontribution',
    CUSTOM_CONTRIBUTIONS = 'customcontribution',
    WORKLOAD = 'workload'
}
